<template>
	<div id="app">

		<div class="headerbox flex_between">
			<div class="pointer flex_start">
				<img class="logicon" src="@/assets/logo.png" />
				<img class="logtitle" src="@/assets/common/logontitle.png" />
			</div>
			<ul class="navitem flex_start">
				<li class="pointer">
					<a href="#viewPage1">公司介绍</a>
				</li>
				<li class="pointer"><a href="#viewPage2">服务领域</a></li>
				<li class="pointer"><a href="#viewPage3">案例分享</a></li>
			</ul>
		</div>
		<div style="height: 90px;"></div>

		<div class="banner1">
			<div class="leftbanner">
				<el-carousel ref="TopBannerCarousel" height="730px" @change="changeTopBaner" indicator-position="none"
					:interval="5000">
					<el-carousel-item v-for="(item,index) in topBanner" :key="index">
						<img class="itembanner" :src="item.url" />
					</el-carousel-item>
				</el-carousel>
				<div class="postbox">
					<img src="@/assets/common/icon1.png" />
					<p style="font-size: 20px;margin-top: 5px;">艾维格莱德尔国际教育</p>
					<p style="margin-top: 5px;opacity: 0.8;font-weight: normal">EDUCA0TION SERVICE</p>
				</div>
				<div class="bannertab flex_center">
					<p @click="changeTopImage(index)" class="pointer" v-for="(item,index) in topBanner" :key="index"
						:style="TopBanerIndex == index ? 'background: #fff' :'background: rgba(255, 255, 255, 0.3);'">
					</p>
				</div>
			</div>
		</div>
		<div class="introducebox">
			<p class="pname1">Company Profile <span class="line"></span></p>
			<div id="viewPage1" class="introduce1 flex_between_d">
				<div class="leftbox" style="width: 50%;padding-right: 100px;">
					<p class="pname2 flex_start"><span class="line"></span>Company Profile</p>
					<p class="iname">企业简介</p>
					<p class="iname2">Business Profile​</p>
					<p class="iname3">
						和昕教育是莱丁教育集团旗下国际文化教育交流服务品牌，是专业从事中外教育文化交流活动、国内外研学服务及国际教育文化交流的综合运营商。经过多年的运作与发展，和昕教育的业务范围涵盖了国际游学&国内研学、海外考察培训、企业家游学，签证办理，机票预订，境外接待，海外移民，海外房产置业等多个领域。在美国、英国及澳大利亚均设有办事处，与美、英、加、澳等国各州政府、旅游局、高等教育机构、经济发展机构等一直保持着良好的合作关系。
					</p>
					<p class="iname">品牌介绍</p>
					<p class="iname2">Brand Introduction</p>
					<p class="iname3">艾维格莱德（Ivyglider）是和昕教育旗下的国际研学品牌， 品牌由英文单词Ivy和Glider组合而成，取意于让我们一起乘风破浪到藤校之意
						。作为国际游学专业教育机构，我们始终致力于为中外学生、老师、学校提供安全、专业、丰富的研学交流服务。
						同时也为满足《教育部等11部门关于国家推进中小学生研学旅行的意见》精神，为传统学校教育进行有益补充提供坚实的服务基础。</p>
				</div>
				<img src="@/assets/common/ins.png" style="width: 40%;height: 385px;object-fit: cover;" />
			</div>
		</div>

		<div class="viewbox2">
			<ul class="tabs flex_center">
				<li>使命</li>
				<li>愿景</li>
				<li>价值观</li>
			</ul>
			<ul class="tabsbox flex_center">
				<li>
					<img src="@/assets/common/sm1.png" style="width: 460px;height: 480px;" />
					<div class="viewtxtbox">
						<p class="txt1">01·使命</p>
						<p class="txt2">帮助中国家庭及孩子打开国际教育之门，提供与世界顶尖教育平台的交流机会。</p>
						<p class="txtline"></p>
					</div>
				</li>
				<li>
					<img src="@/assets/common/sm2.png" style="width: 460px;height: 480px;" />
					<div class="viewtxtbox">
						<p class="txt1">02·愿景</p>
						<p class="txt2">让更多人享受到高品质的国际教育服务，并成为行业的领导者。</p>
						<p class="txtline"></p>
					</div>
				</li>
				<li>
					<img src="@/assets/common/sm3.png" style="width: 460px;height: 480px;" />
					<div class="viewtxtbox">
						<p class="txt1">03·价值观</p>
						<p class="txt2">真诚、热忱、共赢。</p>
						<p class="txtline"></p>
					</div>
				</li>
			</ul>

		</div>

		<div id="viewPage2" class="viewbox3"></div>

		<ul class="viewbox4 flex_start_d">
			<li class="flex_center">
				<p class="nametxt">01·教育规划</p>
			</li>
			<li class="flex_center bgcolorm">
				<div>
					<p class="nametxt flex_center">02·海外游学</p>
					<!--p class="nametxt2">美国营地、英国营地、新加坡营地</p-->
				</div>
			</li>
			<li class="flex_center">
				<p class="nametxt">03·亲子游学</p>
			</li>
			<li class="flex_center bgcolorm">
				<div>
					<p class="nametxt flex_center">04·背景提升</p>
					<!--p class="nametxt2">美国AMC、美国大联盟数学竞赛、袋鼠数学竞赛、澳洲AMC、SASMO、KET/PET/FCE指定报名机构</p-->
				</div>
			</li>
			<li class="flex_center bgcolorm">
				<p class="nametxt">05·夏令营</p>
			</li>
			<li class="flex_center">
				<div>
					<p class="nametxt flex_center">06·低龄留学</p>
					<!--p class="nametxt2">6所美国高中在中国独家的推广和招生工作；超120所美国K12学校在中国的推广和招生工作；连续六年获得CSIET认证英国、新加坡、马来西亚</p-->
				</div>
			</li>
			<li class="flex_center bgcolorm">
				<p class="nametxt">07·冬令营</p>
			</li>
			<li class="flex_center">
				<p class="nametxt">08·插班项目</p>
			</li>
		</ul>

		<div class="viewbox5">
			<div class="carousel-container">
				<el-carousel :interval="4000" :autoplay="true" height="730px" indicator-position="none" arrow="always">
					<el-carousel-item v-for="(group, index) in groupedImages" :key="index" class="multi-image-item">
						<div class="image-group">
							<img v-for="(img, imgIndex) in group" :key="imgIndex" :src="img.url" class="carousel-image">
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>

		</div>

		<div class="viewbox6 flex_between">
			<div class="leftbox">
				<el-carousel :interval="4000" :autoplay="true" height="530px" indicator-position="none" arrow="always">
					<el-carousel-item v-for="(group, index) in groupedImages2" :key="index" class="multi-image-item">
						<div>
							<img v-for="(img, imgIndex) in group" :key="imgIndex" :src="img.url"
								class="carousel-image2">
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="rightbox flex_center">
				<div>
					<p class="txtrvtitle1">Background <br />Enhancement​</p>
					<p class="txtrvtitle2">背景提升</p>
				</div>

			</div>
		</div>

		<div id="viewPage3" class="viewbox7 flex_between">
			<div class="leftbox">
				<p class="txt1">Case <br />Presentation</p>
				<p class="txt2">案例分享</p>
			</div>
			<img src="@/assets/common/anlie1.png" style="width: 211px;height: 164px;" />
		</div>

		<div class="viewbox8">
			<el-carousel ref="AnliBannerCarousel" height="790px" @change="changeAnliBaner" indicator-position="none"
				:interval="5000">
				<el-carousel-item v-for="(item,index) in AnliBanner" :key="index">
					<img class="itembanner" :src="item.url" style="width: 100%;height: 100%;object-fit: cover;" />
				</el-carousel-item>
			</el-carousel>
			<div class="horizontal-scroll-container" >
				<el-carousel ref="scrollContainer" :interval="4000" :autoplay="false" height="118px" indicator-position="none" arrow="never">
					<el-carousel-item v-for="(group, index) in groupedImages3" :key="index" class="multi-image-item">
						<div class="pointer">
							<img @click="changeAnliImage(imgIndex)" :class="AnliBanerIndex == imgIndex ? 'border-red' : ''" v-for="(img, imgIndex) in group" :key="imgIndex" :src="img.url"
								style="width: 118px;
		  height: 118px;object-fit: cover;margin-right: 10px;border: 1px solid inherit;">
						</div>
					</el-carousel-item>
				</el-carousel>
				
			</div>
			
		</div>
		
		<!--div class="viewbox9">
			<p class="flex_center txt1">资历证书</p>
			<p class="flex_center txt2">Qualification Certificates</p>
			<ul class="zsboxitems flex_start" style="margin-top: 30px;">
				<li>
					<img src="@/assets/common/zs1.png" />
				</li>
				<li>
					<img src="@/assets/common/zs2.png" />
				</li>
				<li>
					<img src="@/assets/common/zs3.png" />
				</li>
			</ul>
		</div-->
		
		<div class="footerbox">
			<div class="infofooter">
				<div class="infofooterbox flex_start_t">
					<img class="logicon" src="@/assets/logo.png" />
					<div class="flex_start_t">
						<ul class="ml-100">
							<li class="footertxt1">公司介绍</li>
							<li class="footertxt2">和昕教育简介</li>
							<li class="footertxt2">公司文化</li>
						</ul>
						<ul class="ml-100">
							<li class="footertxt1">服务领域</li>
							<li class="footertxt2">海外游学</li>
							<li class="footertxt2">背景提升</li>
						</ul>
						<ul class="ml-100">
							<li class="footertxt1">案例分享</li>
							<li class="footertxt2">案例分享</li>
						</ul>
						<div class="ml-100">
							<p class="footertxt1">联系我们</p>
							<p class="footertxt2">bob.tsang@hoxinedu.com</p>
							<p class="footertxt4 flex_start"><img src="@/assets/common/adr.png" style="width: 12px;height: 15px;margin-right: 5px;"/>北京市海淀区畅茜园雪芳里6号楼1层102</p>
						</div>
					</div>
				</div>
			</div>
			<p class="bqtxt">和昕教育科技（北京）有限公司  版权所有</p>
			<p class="bqtxt"><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2025138806号</a>
			<br/>
			    <img src="@/assets/common/head-logo.png" width="20"/> <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802046157" rel="noreferrer" target="_blank">京公网安备11010802046157号</a>
			</p>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				TopBanerIndex: 0,
				topBanner: [{
						"url": require("@/assets/common/topbanner1.png")
					},
					{
						"url": require("@/assets/common/topbanner2.png")
					},
					{
						"url": require("@/assets/common/topbanner3.png")
					},
					{
						"url": require("@/assets/common/topbanner4.png")
					},
				],
				dataList: [{
						"url": require("@/assets/common/fw6.png")
					},
					{
						"url": require("@/assets/common/fw7.png")
					},
					{
						"url": require("@/assets/common/fw8.png")
					},
					{
						"url": require("@/assets/common/fw9.png")
					},
				],
				dataList2: [{
						"url": require("@/assets/common/fwa1.png")
					},
					{
						"url": require("@/assets/common/fwa2.png")
					},
					{
						"url": require("@/assets/common/fwa3.png")
					},
				],
				AnliBanerIndex: 0,
				AnliBanner: [
					{
						"url": require("@/assets/common/Anli8.jpg")
					},
					{
						"url": require("@/assets/common/Anli1.jpg")
					},
					{
						"url": require("@/assets/common/Anli2.jpg")
					},
					{
						"url": require("@/assets/common/Anli3.jpg")
					},
					{
						"url": require("@/assets/common/Anli4.jpg")
					},
					{
						"url": require("@/assets/common/Anli5.jpg")
					},
					{
						"url": require("@/assets/common/Anli6.jpg")
					},
					{
						"url": require("@/assets/common/Anli7.jpg")
					},
					
					{
						"url": require("@/assets/common/Anli9.jpg")
					},
					{
						"url": require("@/assets/common/Anli10.jpg")
					},
				],

			}
		},
		computed: {
			groupedImages() {
				const groups = []
				for (let i = 0; i < this.dataList.length; i += 4) {
					groups.push(this.dataList.slice(i, i + 4))
				}
				return groups
			},
			groupedImages2() {
				const groups = []
				for (let i = 0; i < this.dataList2.length; i += 3) {
					groups.push(this.dataList2.slice(i, i + 3))
				}
				return groups
			},
			groupedImages3() {
				const groups = []
				for (let i = 0; i < this.AnliBanner.length; i += 10) {
					groups.push(this.AnliBanner.slice(i, i + 10))
				}
				return groups
			}
		},
		mounted() {

		},
		methods: {
			changeTopBaner(index) {
				this.TopBanerIndex = index;
			},
			changeTopImage(index) {
				this.$refs.TopBannerCarousel.setActiveItem(index);
			},
			changeAnliBaner(index) {
				console.log(index)
				this.AnliBanerIndex = index;
			},
			changeAnliImage(index) {
				this.$refs.AnliBannerCarousel.setActiveItem(index);
			},
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}

	a {
		color: inherit;
		text-decoration: none;
	}

	ul,
	ol {
		list-style: none;
	}
	body{
		background: #E7E7E7;
		min-height: 100vh;
	}
	.footerbox{
		position: relative;
		padding: 0;
		box-sizing: border-box;
		background: #181A1C;
	}
	.footerbox .infofooter{
		padding: 80px;
	}
	.footerbox .infofooter .infofooterbox{
		width: 1100px;
		margin-left: auto;
		margin-right: auto;
	}
	.footertxt1{
		font-size: 20px;
		color: #AFAFAF;
		margin-bottom: 10px;
	}
	.footertxt2{
		font-size: 14px;
		color: #AFAFAF;
		margin-bottom: 10px;
	}
	.footertxt3{
		font-size: 24px;
		color: #AFAFAF;
		margin-bottom: 10px;
	}
	.footertxt4{
		font-size: 14px;
		color: #AFAFAF;
		margin-bottom: 10px;
	}
	.footerbox .bqtxt{
		border-top: 1px solid #252729;
		padding: 30px;
		font-size: 14px;
		text-align: center;
		box-sizing: border-box;
		color:#AFAFAF ;
	}
	.ml-100{
		margin-left: 120px;
	}
	.viewbox9{
		position: relative;
		padding: 30px;
		background: #2E3233;
		box-sizing: border-box;
	}
	.viewbox9 .zsboxitems{
		position: relative;
		width: 1300px;
		margin: 0 auto;
	}
	.viewbox9 .zsboxitems li{
		width: 400px;
		height: 260px;
		margin-right: 40px;
	}
	.viewbox9 .zsboxitems li img{
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.viewbox9 .txt1{
		font-size: 24px;
		font-weight: bold;
		color: #fff;
	}
	.viewbox9 .txt2{
		margin-top: 10px;
		color: #fff;
		font-size: 16px;
		font-weight: bold;
		text-transform: uppercase;
		letter-spacing: 6px;
	}
	.horizontal-scroll-container {
		margin-top: 15px;
	  position: relative;
	  width: 100%;
	 
	}
	.border-red{
		border: 1px solid #ff0000;
	}
	
	.viewbox8{
		position: relative;
		width: 1300px;
		margin: 60px auto;
	}
	
	.viewbox7 {
		position: relative;
		padding: 60px 240px;
		box-sizing: border-box;
		background: #32373A;
	}

	.viewbox7 .leftbox .txt1 {
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		text-transform: uppercase;
		letter-spacing: 6px;
	}

	.viewbox7 .leftbox .txt2 {
		margin-top: 10px;
		color: #fff;
		font-size: 24px;
		font-weight: bold;
		text-align: left;
	}

	.viewbox6 {
		position: relative;
		min-width: 1400px;
		margin-left: auto;
		margin-right: auto;
	}

	.viewbox6 .leftbox {
		width: 50%;
	}

	.viewbox6 .rightbox {
		width: 50%;
	}

	.viewbox6 .rightbox .txtrvtitle1 {
		color: #343637;
		font-size: 20px;
		font-weight: bold;
		text-transform: uppercase;
		letter-spacing: 6px;
	}

	.viewbox6 .rightbox .txtrvtitle2 {
		margin-top: 10px;
		color: #2E3032;
		font-size: 24px;
		font-weight: bold;
		text-align: right;
	}

	.viewbox5 {
		position: relative;
		min-width: 1400px;
		margin-left: auto;
		margin-right: auto;
	}

	.carousel-container {
		width: 100%;
		max-width: 1400px;
		margin: 0 auto;
	}

	.multi-image-item {
		display: flex;
		justify-content: center;
	}

	.image-group {
		display: flex;
		width: 100%;
		justify-content: space-around;
		padding: 0 20px;
	}

	.carousel-image {
		cursor: pointer;
		width: 25%;
		height: 100%;
		object-fit: fill;
		border-radius: 8px;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease;
	}

	.carousel-image:hover {
		transform: scale(1.05);
	}

	.carousel-image2 {
		cursor: pointer;
		width: 33.33%;
		height: 100%;
		object-fit: fill;
		border-radius: 8px;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease;
	}

	.carousel-image2:hover {
		transform: scale(1.05);
	}

	.el-carousel__indicators--outside {
		bottom: -30px;
	}

	.viewbox4 {
		position: relative;
		flex-wrap: wrap;
	}

	.viewbox4 li {
		width: 25%;
		background: #2E3235;
		min-height: 300px;
	}

	.viewbox4 li p.nametxt {
		font-size: 20px;
		color: #fff;
	}

	.viewbox4 li p.nametxt2 {
		font-size: 14px;
		color: #fff;
		margin-top: 10px;
		width: 240px;
	}

	.bgcolorm {
		background: #32373A !important;
	}

	.viewbox3 {
		position: relative;
		margin-top: 150px;
		width: 100%;
		background: url('@/assets/common/fw1.png') no-repeat;
		background-size: 100% 100%;
		height: 840px;
	}

	.viewbox2 {
		position: relative;
		margin-top: 100px;
	}

	.viewbox2 .tabs {
		width: 1400px;
		margin: 0 auto;
		padding-bottom: 10px;
		border-bottom: 1px solid #CFCFCF;
	}

	.viewbox2 .tabs li {
		color: #043451;
		font-weight: bold;
		font-size: 16px;
		margin-right: 60px;
	}

	.viewbox2 .tabsbox {
		padding: 0 30px;
		width: 1200px;
		margin: 0 auto;
		margin-top: 30px;
		box-sizing: border-box;
	}

	.viewbox2 .tabsbox li {
		margin-right: 15px;
		position: relative;
	}

	.viewbox2 .tabsbox li .viewtxtbox {
		position: absolute;
		left: 50%;
		margin-left: -190px;
		bottom: -85px;
		width: 380px;
		min-height: 143px;
		padding: 20px;
		background: #E7E7E7;
		box-sizing: border-box;
		cursor: pointer;
	}

	.viewbox2 .tabsbox li .viewtxtbox .txt1 {
		font-size: 22px;
		text-align: center;
		font-weight: bold;
		color: #043451;
	}

	.viewbox2 .tabsbox li .viewtxtbox .txt2 {
		margin-top: 10px;
		font-size: 16px;
		min-height: 42px;
		color: #043451;
	}

	.viewbox2 .tabsbox li .viewtxtbox .txtline {
		margin-top: 20px;
		width: 80px;
		height: 2px;
		margin-left: auto;
		margin-right: auto;
		background: #043451;
	}

	.viewbox2 .tabsbox li .viewtxtbox:hover {
		background: #043451;
	}

	.viewbox2 .tabsbox li .viewtxtbox:hover .txt1 {
		color: #fff;
	}

	.viewbox2 .tabsbox li .viewtxtbox:hover .txt2 {
		color: #fff;
	}

	.viewbox2 .tabsbox li .viewtxtbox:hover .txtline {
		background: #fff;
	}

	.introducebox {
		position: relative;
		padding-left: 240px;
		margin-top: 200px;
	}

	.introduce1 .leftbox .iname {
		margin-top: 20px;
		color: #343637;
		font-size: 20px;
		font-weight: bold;
		letter-spacing: 8px;
	}

	.introduce1 .leftbox .iname2 {
		margin-top: 10px;
		color: #343637;
		font-size: 20px;
		font-weight: bold;
		text-transform: uppercase;
		letter-spacing: 6px;
	}

	.introduce1 .leftbox .iname3 {
		margin-top: 10px;
		color: #343637;
		font-size: 16px;
	}

	.introducebox .pname1 {
		position: absolute;
		top: -165px;
		right: 60px;
		width: 10px;
		height: 180px;
		text-transform: uppercase;
		font-size: 14px;
		letter-spacing: 1px;
		writing-mode: vertical-lr;
	}

	.introducebox .pname1 .line {
		margin-top: 5px;
		display: inline-block;
		width: 1px;
		height: 18px;
		background: #7C7C7C;
	}

	.introducebox .pname2 {
		font-size: #343637;
		text-transform: uppercase;
		font-size: 16px;
		letter-spacing: 4px;
	}

	.introducebox .pname2 .line {
		display: inline-block;
		margin-right: 5px;
		width: 90px;
		height: 2px;
		background: #7C7C7C;
	}

	.introducebox .introduce1 {
		position: relative;
		padding-top: 50px;
		width: 100%;
	}

	.postbox {
		position: absolute;
		top: 300px;
		left: 252px;
		z-index: 12;
		text-align: left;
	}

	.postbox img {
		display: block;
		width: 154px;
		height: 64px;
	}

	.postbox p {
		font-size: 18px;
		color: #fff;
		font-weight: bold;
	}

	.headerbox {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 99;
		background: #2E3235;
		height: 90px;
		padding-left: 72px;
		padding-right: 149px;
	}

	.logicon {
		width: 60px;
		height: 60px;
		cursor: pointer;
	}

	.logtitle {
		margin-left: 16px;
		width: 161px;
		height: 40px;
	}

	.navitem li {
		color: #fff;
		font-size: 16px;
		margin-left: 100px;
	}

	.banner1 {
		position: relative;
		height: 650px;
		background: #2E3235;
	}

	.leftbanner {
		position: relative;
		width: 92.5%;
		height: 730px;
		background: #2E3235;
	}

	.leftbanner .itembanner {
		width: 100%;
		height: 100%;
		display: block;
		object-fit: contain;
		opacity: 0.5;
	}

	.bannertab {
		width: 700px;
		height: 50px;
		background: #043451;
	}

	.bannertab p {
		width: 30px;
		height: 4px;
		margin-right: 30px;
		background: rgba(255, 255, 255, 0.3);
	}

	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		background: #E7E7E7;
		color: #333;
		min-height: 100vh;
		min-width: 1400px;
	}

	.small-carousel {
		margin-top: 20px;
		/* width: 100px; */
		height: 100px;
		cursor: pointer;
	}

	.small-carousel .items {
		width: 100px;
		height: 100px;
	}


	.small-carousel img {
		width: 100px;
		height: 100px;
		object-fit: cover;
	}

	/* 布局两边居中 */
	.flex_between {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
	}

	.flex_between_t {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: flex-start;
		justify-content: space-between;
		box-sizing: border-box;
	}

	.flex_between_d {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: flex-end;
		justify-content: space-between;
		box-sizing: border-box;
	}

	.flex_around {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: center;
		justify-content: space-around;
		box-sizing: border-box;
	}

	.flex_around_t {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: flex-start;
		justify-content: space-around;
		box-sizing: border-box;
	}

	/* 布局居左 */
	.flex_start {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: center;
		justify-content: flex-start;
		box-sizing: border-box;
	}

	/* 布局居左上 */
	.flex_start_t {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: flex-start;
		justify-content: flex-start;
		box-sizing: border-box;
	}

	/* 布局居左下 */
	.flex_start_d {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: flex-end;
		justify-content: flex-start;
		box-sizing: border-box;
	}

	/* 布局居右 */
	.flex_end {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: center;
		justify-content: flex-end;
		box-sizing: border-box;
	}

	/* 布局居右下 */
	.flex_end_d {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: flex-end;
		justify-content: flex-end;
		box-sizing: border-box;
	}

	/* 布局居中 */
	.flex_center {
		/*flex 布局*/
		display: flex;
		/*实现垂直居中*/
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}

	/* 单行文本溢出 */
	.text-ellipsis {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		lines: 1;
	}

	.text-multirow {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.pointer {
		cursor: pointer;
		user-select: none;
	}
</style>